import { Checkbox } from "shared";
import {
    ITemplateComponent,
    ITemplateLanguageComponent,
} from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import styles from "./component_form_language.module.scss";

interface IComponentFormLanguageProps {
    component: ITemplateLanguageComponent;
    onChange: (component: ITemplateComponent) => void;

}

export const ComponentFormLanguage: React.FC<IComponentFormLanguageProps> = React.memo(({
                                                                                            component,
                                                                                            onChange
                                                                                        }) => {
    const t = useComponentsTranslations();

    const onFieldChange = (value: Partial<ITemplateLanguageComponent>) => {
        onChange({
            ...component,
            ...value
        })
    }

    return <div className={styles.container}>
        <div className={styles.description}>{t("languageComponentDescription")}</div>
        <Checkbox
            label={t("storeEnLang")}
            size="m"
            onChange={() => onFieldChange({ isLangEn: !component.isLangEn })}
            checked={component.isLangEn}
        />
    </div>;
});
